import QuotesService from './QuotesService'

export default QuotesService
